function checkNextTime(name, timeout) {
  const timestampString = localStorage.getItem(name);
  const timestamp = timestampString ? Number(timestampString) : undefined;

  return !timestamp || timestamp + timeout <= new Date().getTime();
}

export default checkNextTime;
